var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6582 3.38301C19.9499 3.67467 20.0957 4.02001 20.0957 4.41901C20.0957 4.81723 19.9499 5.16217 19.6582 5.45384L11.1124 13.9997L19.6874 22.5747C19.9596 22.8469 20.0957 23.1872 20.0957 23.5955C20.0957 24.0038 19.9499 24.3538 19.6582 24.6455C19.3665 24.9372 19.0212 25.083 18.6222 25.083C18.224 25.083 17.879 24.9372 17.5874 24.6455L7.78737 14.8163C7.6707 14.6997 7.58787 14.5733 7.53887 14.4372C7.49065 14.3011 7.46653 14.1552 7.46653 13.9997C7.46653 13.8441 7.49065 13.6983 7.53887 13.5622C7.58787 13.4261 7.6707 13.2997 7.78737 13.183L17.6165 3.35384C17.8888 3.08162 18.224 2.94551 18.6222 2.94551C19.0212 2.94551 19.3665 3.09134 19.6582 3.38301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.0baf3bfca10cc040a263d7b4418bd309.svg";
export { ForwardRef as ReactComponent };